import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppConfigService } from '@app/core/app-config/app-config.service';
import { ComponentBase } from '@core/base/base.component.base';
import { interval, Observable } from 'rxjs';
import { finalize, map, take, takeUntil, tap } from 'rxjs/operators';
import { DialogMessageData } from '../dialog.model';

@Component({
  selector: 'app-dialog-confirm',
  templateUrl: 'dialog-confirm.component.html',
  styleUrls: ['../dialog-common.scss', './dialog-confirm.component.scss']
})
export class DialogConfirmComponent extends ComponentBase implements OnInit {
  disableClose = true;
  remainingTimeSec: number;
  private readonly oneSecond = 1000;
  constructor(
    public dialogRef: MatDialogRef<DialogConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogMessageData<null>,
    private appConfigService: AppConfigService
  ) {
    super();
    this.remainingTimeSec = this.appConfigService.getAppValue<number>('timerExtensionDialog') as number;
  }

  ngOnInit(): void {
    this.setDialogDisableClose();

    if (this.data.isTimerVisible) {
      const timerExtension: number = this.appConfigService.getAppValue<number>('timerExtensionDialog') as number;
      this.timerToClose(timerExtension).subscribe();
    }
  }

  /** Starts a countdown timer based on the environment */
  timerToClose(timeSec: number): Observable<number> {
    return interval(this.oneSecond).pipe(
      take(timeSec),
      map((v: number) => timeSec - 1 - v),
      tap((v: number) => (this.remainingTimeSec = v)),
      finalize(() => {
        if (this.remainingTimeSec === 0) {
          this.onConfirmationSelected(undefined);
        }
      }), // to reach zero
      takeUntil(this.ngUnsubscribe)
    );
  }

  /** Triggered by button in dom, closes the dialog with positive or negative result. */
  onConfirmationSelected(result: boolean | undefined): void {
    this.dialogRef.close(result);
  }

  /** Closes dialog without result - triggered from close button in the DOM. */
  dismissDialog(): void {
    this.dialogRef.close(undefined);
  }

  /**
   * Determine if the modal can be dismissed via backdrop and close button in the DOM.
   * This is disabled by default as guest action is required unless specified.
   */
  setDialogDisableClose(): void {
    this.dialogRef.disableClose = this.disableClose =
      typeof this.data?.disableClose === 'boolean' ? this.data.disableClose : true;
  }
}
